

/*
 ######     #######   ##    ##   ########   
##    ##   ##     ##  ###   ##   ##         
##         ##     ##  ####  ##   ##         
##         ##     ##  ## ## ##   ######     
##         ##     ##  ##  ####   ##         
##    ##   ##     ##  ##   ###   ##         
 ######     #######   ##    ##   ##         
*/

// NE PAS MODIFIER //

// Récupération de l'url courante
var currentURL         = window.location.href;

// utilisation des transitions de page via TweenMax
var showLoader         = null;
var hideLoader         = null;

// Définition de la fonction principale du site
var pageInit           = null;

// END NE PAS MODIFIER //


// VARIABLES MODIFIABLES //

// Passer à TRUE si vous souhaitez utiliser les transitions showLoader et hideLoader
var pageTransition = false;

// Passer à true si vous souhaitez utiliser les transition Ajax via BarbaJs
var pageAjax = true;

// Définition du breakpoint d'initialisation des effets parallax
var parallaxBreakpoint = 768;

/*
 ######     #######   ##    ##    ######     #######   ##         ########   
##    ##   ##     ##  ###   ##   ##    ##   ##     ##  ##         ##         
##         ##     ##  ####  ##   ##         ##     ##  ##         ##         
##         ##     ##  ## ## ##    ######    ##     ##  ##         ######     
##         ##     ##  ##  ####         ##   ##     ##  ##         ##         
##    ##   ##     ##  ##   ###   ##    ##   ##     ##  ##         ##         
 ######     #######   ##    ##    ######     #######   ########   ########   
*/

/*	Permet l'ajout de 2 paramètres à la fonction console.log():
	- $bg : couleur de fond du message
	- $color : couleur du texte du message
*/	
(function () {
	consoleLog = function ($message, $bg, $color) {
		console.log('%c' + $message, 'background-color:' + $bg + '; color:' + $color + ';padding:3px 5px;');
	};
})();

// /*	Affiche un message personnalisé dans la console */
consoleLog( ' ' );
consoleLog( 'Fabriqué à Lyon par Mcube', '#FA3348', '#ffffff' );
console.log( 'www.mcube.fr' );
consoleLog( ' ' );